import { g as n } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const m = {
  name: "DtIconSun",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, r, _, g, i) {
  return d(), s("svg", {
    "aria-label": r.ariaLabel,
    class: o([i.iconSizeClass, "d-icon d-icon--sun"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Sun",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M6 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3.5 6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM6 .5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V1A.5.5 0 0 1 6 .5Zm0 9a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5ZM2.111 2.111a.5.5 0 0 1 .708 0l.705.705a.5.5 0 1 1-.708.708l-.705-.705a.5.5 0 0 1 0-.708Zm6.365 6.365a.5.5 0 0 1 .708 0l.705.705a.5.5 0 0 1-.708.708l-.705-.705a.5.5 0 0 1 0-.708ZM.5 6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 6Zm9 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM3.524 8.476a.5.5 0 0 1 0 .708l-.705.705a.5.5 0 0 1-.708-.708l.705-.705a.5.5 0 0 1 .708 0Zm6.365-6.365a.5.5 0 0 1 0 .708l-.705.705a.5.5 0 0 1-.708-.708l.705-.705a.5.5 0 0 1 .708 0Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, c);
}
const M = /* @__PURE__ */ u(m, [["render", h]]);
export {
  M as default
};
//# sourceMappingURL=sun.js.map
